import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/layout/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const DoDontRow = makeShortcode("DoDontRow");
const DoDont = makeShortcode("DoDont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Foundation`}</h2>
    <p>{`Chips are a simple component consisting only of a container and text label.`}</p>
    <img {...{
      "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/chips/guideline-1.svg",
      "alt": "foundation guideline"
    }}></img>
    <h2>{`Container`}</h2>
    <p>{`Chips are a simple component consisting only of a container and text label.`}</p>
    <img {...{
      "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/chips/guideline-2.svg",
      "alt": "guideline chips container"
    }}></img>
    <div className="divi" />
    <h2>{`Padding`}</h2>
    <p>{`Text labels are surrounded by even padding on all sides to ensure legibility and provide visual balance. Padding around the container should be kept tight enough that the chips can fit within small spaces but wide enough to support legibility.`}</p>
    <DoDontRow mdxType="DoDontRow">
  <DoDont type="do" captionTitle="Do" caption="provide chips with enough padding to be legible." aspectRatio="16:9" colLg="6" mdxType="DoDont">
        <img {...{
          "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/chips/guideline-3.svg",
          "alt": "Alt text"
        }}></img>
      </DoDont>
      <DoDont type="dont" captionTitle="Don't" caption="Provide chips with little padding" aspectRatio="16:9" colLg="6" mdxType="DoDont">
        <img {...{
          "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/chips/guideline-4.svg",
          "alt": "Alt text"
        }}></img>
      </DoDont>
    </DoDontRow>
    <h2>{`Text label`}</h2>
    <p>{`The text label within a container relays tertiary information pertaining to other content it is closest too. Labels should be kept short and to the point
DontRow>`}</p>
    <DoDontRow mdxType="DoDontRow">
      <DoDont type="do" captionTitle="Do" caption="provide chips with direct and concise  labels." aspectRatio="16:9" colLg="6" mdxType="DoDont">
        <img {...{
          "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/chips/guideline-5.svg",
          "alt": "Alt text"
        }}></img>
      </DoDont>
      <DoDont type="dont" captionTitle="Don't" caption="Provide chips with too texty labels" aspectRatio="16:9" colLg="6" mdxType="DoDont">
        <img {...{
          "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/chips/guideline-6.svg",
          "alt": "Alt text"
        }}></img>
      </DoDont>
    </DoDontRow>
    <h2>{`Margins`}</h2>
    <p>{`Always provide adequate margins around and between chips to support visual hierarchy and balance. We recommend a minimum 12 pixel margin between boxes and other elements, however this can be adjusted based on page density.`}</p>
    <DoDontRow mdxType="DoDontRow">
  <DoDont type="do" captionTitle="Do" caption="provide chips with proper margins to be legible." aspectRatio="16:9" colLg="6" mdxType="DoDont">
        <img {...{
          "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/chips/guideline-7.svg",
          "alt": "Alt text"
        }}></img>
      </DoDont>
      <DoDont type="dont" captionTitle="Don't" caption="provide chips with too little margins" aspectRatio="16:9" colLg="6" mdxType="DoDont">
        <img {...{
          "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/chips/guideline-8.svg",
          "alt": "Alt text"
        }}></img>
      </DoDont>
    </DoDontRow>
    <div className="divi" />
    <h2>{`Placement`}</h2>
    <p>{`Chips can be placed wherever the main content they are supporting can be placed.`}</p>
    <h2>{`General usage`}</h2>
    <p>{`So long as chips are kept in close proximity to the content they are supporting, the placement of chips around that content is very flexible. Keeping chips in close proximity to the content they support is important because it allows users to make the connection between the two.`}</p>
    <img {...{
      "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/chips/guideline-9.svg",
      "alt": "general usage chips"
    }}></img>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      